'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import SplideSlider from '@components/SplideSlider';
import { ImageObj } from '@custom-types/ImageObj.types';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
interface WildsLaunchGalleryProps {
  t: any;
  galleryImages: Array<ImageObj>;
  galleryMobileSlideImages: Array<ImageObj>;
  galleryClipImage: ImageObj;
}
const wildsLaunchGallerySettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 900,
  perMove: 1,
  perPage: 1,
  start: 1,
  drag: false,
  pauseOnHover: false,
};
export default function WildsLaunchGallery(props: WildsLaunchGalleryProps) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.welcomeGallery}>
      <Box className={cn.welcomeGallerySlides}>
        <Mobile>
          <SplideSlider
            options={wildsLaunchGallerySettings}
            className="orientalSlider"
          >
            {props.galleryMobileSlideImages.map((image, index) => (
              <Box
                component="picture"
                key={index}
                className={cn.sliderGalleryStory}
              >
                <Image
                  src={image.url}
                  alt={`Wilds Launch Gallery - Gallery Mobile Slide Images ${index + 1}`}
                  layout="responsive"
                  width={600}
                  height={400}
                />
              </Box>
            ))}
          </SplideSlider>
        </Mobile>
        <Desktop>
          <SplideSlider
            options={wildsLaunchGallerySettings}
            className="orientalSlider"
          >
            {props.galleryImages.map((image, index) => (
              <Box
                component="picture"
                key={index}
                className={cn.sliderGalleryStory}
              >
                <Image
                  src={image.url}
                  alt={`Wilds Launch Gallery - Gallery Images ${index + 1}`}
                  layout="responsive"
                  width={600}
                  height={400}
                />
              </Box>
            ))}
          </SplideSlider>
        </Desktop>
      </Box>
    </Stack>
  );
}
